const UnitToggle = ({ value, onChange }) => {
  return (
    <div className="flex bg-overlay rounded-2xl p-1 gap-1 mb-2.5">
      <button
        type="button"
        onClick={() => onChange("imperial")}
        className={`
          flex-1 py-3 px-4 border-none rounded-xl cursor-pointer
          transition-all duration-200
          min-h-[40px] md:min-h-[48px] text-[0.9rem] md:text-[0.95rem] font-medium
          select-none outline-none [-webkit-tap-highlight-color:transparent]
          ${
            value === "imperial"
              ? "bg-white text-main"
              : "bg-transparent text-gray hover:text-main"
          }
        `}
      >
        Imperial
      </button>
      <button
        type="button"
        onClick={() => onChange("metric")}
        className={`
          flex-1 py-3 px-4 border-none rounded-xl cursor-pointer
          transition-all duration-200
          min-h-[40px] md:min-h-[48px] text-[0.9rem] md:text-[0.95rem] font-medium
          select-none outline-none [-webkit-tap-highlight-color:transparent]
          ${
            value === "metric"
              ? "bg-white text-main"
              : "bg-transparent text-gray hover:text-main"
          }
        `}
      >
        Metric
      </button>
    </div>
  );
};

export default UnitToggle;
